import OptionsPanel from "./OptionsPanel.js"

export default class CharacterEdgeStyle extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Character Edge Style" // TODO: This needs to be localized
    this.setting = "edgeType"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
